import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
// import { animateScroll as scroll } from "react-scroll";
import { Autoplay } from "swiper/modules";
import AddressAutocomplete from "../CustomGooglePlaceAPi/AddressAutocomplete";
import { showErrorToast, showSuccessToast } from "../../assets/toastUtils";
import { getDecryptedData, saveEncryptedData } from "../../utils/crypto";
import { useNavigate } from "react-router-dom";

const AgentRegistration = ({ setAgentPopup, agentPopup }) => {
  const [multiStep, setMultiStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const BearerToken = getDecryptedData("userToken");
  const [formData, setFormData] = useState({
    business_email: "",
    name: "",
    business_name: "",
    phone: "",
    website_link: "",
    gst: "",
    pan: "",
    tan: "",
    zipcode: "",
    person_name: "",
    person_email: "",
    person_contact: "",
    password: "",
    confirm_password: "",
  });

  const validate = () => {
    const errors = {};
    if (!formData?.business_email.trim()) {
      errors.business_email = "required";
    }
    if (!formData?.password.trim()) {
      errors.password = "required";
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      return true;
    } else {
      return false;
    }

    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const handleAddressData = (data) => {
    // console.log(data, "data");
    setAddressData(data);
  };

  const agentLogin = async (e) => {
    e.preventDefault();
    const valid = validate();
    setTimeout(() => {
      setFormErrors({});
    }, 1500);

    // if (!valid) {
    //   showErrorToast("Please fill the above details.");
    //   return;
    // }

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      type: "agent",
      email: formData?.business_email,
      password: formData?.business_email,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/login`,
        requestOptions
      );
      const result = await response.json();

      if (result?.success) {
        if (result.data.accountStatus === "InActive") {
          //   showErrorToast(
          //     "Your Status is InActive, Please activate your status first!"
          //   );
        } else {
          localStorage.setItem("token", result.data.token);
          saveEncryptedData("userToken", result.data.token);
          //   showSuccessToast(result.message || "Login Successfully!");

          //   setMultiStep(3);
        }
      } else {
        // showErrorToast(result.message || "Login Failed");
      }
    } catch (error) {
      showErrorToast("Login Failed");
      console.error("Error logging in agent:", error);
    } finally {
      setLoading(false);
    }
  };
  const subscribeUser = async ({ listId, email, fullname }) => {
    const url = "https://app.ucampaign.in/api/v1/subscribers";
    const apiToken =
      "VuzaEMRQCTI8Tur4GRe4L2f7s4GSMrgRLcY6ba1Gxy9PQjETOXPqQy6X4NVV";

    const [firstName, ...lastNameArr] = fullname?.split(" ");
    const lastName = lastNameArr.join(" ") || "-";

    const postData = new URLSearchParams({
      api_token: apiToken,
      list_uid: listId,
      EMAIL: email,
      FIRST_NAME: firstName,
      LAST_NAME: lastName,
      tag: "website-agent",
      status: "subscribed",
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: postData,
      });

      return response.status === 200;
    } catch (error) {
      console.error("Error subscribing user:", error);
      return false;
    }
  };

  const registerAgent = async (e) => {
    e.preventDefault();
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const raw = JSON.stringify({
      type: "agent",
      name: formData?.name,
      email: formData?.business_email,
      callbackUrl: "https://mountainmysteries.com",
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/accounts/register`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        showSuccessToast(result.message);

        await subscribeUser({
          listId: "67ac8148058ce",
          email: formData?.business_email,
          fullname: formData?.name,
        });

        setFormData((prev) => ({
          ...prev,
          name: "",
          business_email: "",
        }));
        setAgentPopup(false)

        // agentLogin();
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      showErrorToast("Error registering Agent");
      console.error("Error registering user:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!validate()) {
    //   showErrorToast("Please fill the above details.");
    //   return;
    // }

    const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/website/agent/update`;

    const headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${BearerToken}`);
    headers.append("Cookie", process.env.REACT_APP_COOKIE);

    const payload = JSON.stringify({ ...formData, ...addressData });

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: payload,
        redirect: "follow",
      });

      const result = await response.json();
      if (result?.success) {
        showSuccessToast("Registered Successfully");
        navigate("/login/agent");
        setMultiStep(1);
        setFormData({});
        localStorage.clear();
        // naviga

        // localStorage.setItem("isVerified", result?.data?.status || "false");

        // window.location.reload();
      } else {
        // showErrorToast(result.message);
      }
    } catch (error) {
      //   console.error("Error updating profile:", error);
      //   showErrorToast("An error occurred while updating your profile.");
    }
  };
  const popupRef = useRef(null);

  return (
    <div className="bg-backdrop">
      {" "}
      <section className="" id="agentRegister">
        <div
          onClick={() => setAgentPopup(false)}
          style={{ textAlign: "end", margin: "10px 0px 5px 0" }}
        >
          {" "}
          <svg
            height="20px"
            width="20px"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 26"
          >
            <g>
              <path
                style={{ fill: "#fff" }}
                d="M21.125,0H4.875C2.182,0,0,2.182,0,4.875v16.25C0,23.818,2.182,26,4.875,26h16.25
		C23.818,26,26,23.818,26,21.125V4.875C26,2.182,23.818,0,21.125,0z M18.78,17.394l-1.388,1.387c-0.254,0.255-0.67,0.255-0.924,0
		L13,15.313L9.533,18.78c-0.255,0.255-0.67,0.255-0.925-0.002L7.22,17.394c-0.253-0.256-0.253-0.669,0-0.926l3.468-3.467
		L7.221,9.534c-0.254-0.256-0.254-0.672,0-0.925l1.388-1.388c0.255-0.257,0.671-0.257,0.925,0L13,10.689l3.468-3.468
		c0.255-0.257,0.671-0.257,0.924,0l1.388,1.386c0.254,0.255,0.254,0.671,0.001,0.927l-3.468,3.467l3.468,3.467
		C19.033,16.725,19.033,17.138,18.78,17.394z"
              />
            </g>
          </svg>
        </div>
        <div className="register_container">
          {" "}
          <div className="LoginVendor_registerMain ">
            <div className="first_row_data">
              <Swiper
                loop={true}
                slidesPerView={3}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                speed={500}
                modules={[Autoplay]}
                className="footer_support_section_slider"
                breakpoints={{
                  320: { slidesPerView: 1, spaceBetween: 10 }, // Small screens
                  640: { slidesPerView: 2, spaceBetween: 20 }, // Tablets
                  1024: { slidesPerView: 3, spaceBetween: 30 }, // Deskt
                }}
              >
                <SwiperSlide>
                  <div className="flex align_items_center flex_gap_5 justify_content_center mt-10">
                    <h3>150+</h3>
                    <span>Exotic Hotels</span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="flex align_items_center flex_gap_5 justify_content_center mt-10">
                    <h3>22+</h3>
                    <span>years of experience</span>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="flex align_items_center flex_gap_5 justify_content_center mt-10">
                    <h3>5,000+</h3>
                    <span>travel packages sold</span>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
            {multiStep === 1 && (
              <>
                {" "}
                <form action="" onSubmit={registerAgent}>
                  <div>
                    {" "}
                    <div className="LoginVendor_registerForm flex">
                      <h3>Create Your Free Account</h3>
                      <div className="w-full LoginVendor_registerForm_entry"></div>
                      <div className=" w-full">
                        {" "}
                        <div>
                          <label htmlFor="" className="text-black">
                            Name*
                          </label>
                          <input
                            className="w-full rounded_0"
                            name="name"
                            onChange={handleInputChange}
                            value={formData?.name}
                            type="text"
                            placeholder="Enter name"
                            required
                          />
                        </div>
                        <div className="mt-10">
                          <label htmlFor="" className="text-black">
                            Business Email*
                          </label>
                          <input
                            style={
                              formErrors.email && {
                                backgroundColor: "#ff000040",
                                border: "1px solid red",
                              }
                            }
                            className="w-100 rounded_0"
                            onChange={handleInputChange}
                            name="business_email"
                            value={formData?.business_email}
                            type="email"
                            placeholder="Enter email"
                          />
                        </div>
                      </div>
                      <div className="LoginVendor_registerForm_btn w-full">
                        <button type="submit" className="red_new_btn_black">
                          continue
                        </button>
                      </div>{" "}
                      {/* <div className="account_desc">
            already have an account? <span>Sign in</span>
          </div> */}
                    </div>
                  </div>
                </form>
                {/* stgiu */}
              </>
            )}
            {/* {multiStep === 2 && (
       <form action="" onSubmit={registerAgent}>
         <div>
           {" "}
           <div className="LoginVendor_registerForm flex">
             <h3>Create Password</h3>
             <div className="w-full LoginVendor_registerForm_entry">
               <div className="relative">
                 <label htmlFor="" className="text-black">
                   Enter Password*
                 </label>
                 <input
                   className="w-full rounded_0"
                   name="password"
                   value={formData?.password}
                   onChange={handleInputChange}
                   type={showPassword ? "text" : "password"}
                   placeholder="Enter password"
                 />{" "}
                 {showPassword ? (
                   <svg
                     onClick={() => setShowPassword(false)}
                     style={{
                       position: "absolute",
                       top: "32px",
                       right: "5px",
                       cursor: "pointer",
                     }}
                     xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     viewBox="0 0 24 24"
                     fill="none"
                   >
                     <path
                       d="M2 2L22 22"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                   </svg>
                 ) : (
                   <svg
                     onClick={() => setShowPassword(true)}
                     style={{
                       position: "absolute",
                       top: "32px",
                       right: "5px",
                       cursor: "pointer",
                     }}
                     xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     viewBox="0 0 14 10"
                     fill="none"
                   >
                     <g clipPath="url(#clip0_1_298)">
                       <path
                         d="M7.00001 3.25C6.53588 3.25 6.09076 3.43437 5.76257 3.76256C5.43438 4.09075 5.25001 4.53587 5.25001 5C5.25001 5.46413 5.43438 5.90925 5.76257 6.23744C6.09076 6.56563 6.53588 6.75 7.00001 6.75C7.46414 6.75 7.90926 6.56563 8.23745 6.23744C8.56564 5.90925 8.75001 5.46413 8.75001 5C8.75001 4.53587 8.56564 4.09075 8.23745 3.76256C7.90926 3.43437 7.46414 3.25 7.00001 3.25ZM7.00001 7.91667C6.22646 7.91667 5.4846 7.60938 4.93762 7.06239C4.39063 6.51541 4.08334 5.77355 4.08334 5C4.08334 4.22645 4.39063 3.48459 4.93762 2.93761C5.4846 2.39062 6.22646 2.08333 7.00001 2.08333C7.77356 2.08333 8.51542 2.39062 9.0624 2.93761C9.60939 3.48459 9.91668 4.22645 9.91668 5C9.91668 5.77355 9.60939 6.51541 9.0624 7.06239C8.51542 7.60938 7.77356 7.91667 7.00001 7.91667ZM7.00001 0.625C4.08334 0.625 1.59251 2.43917 0.583344 5C1.59251 7.56083 4.08334 9.375 7.00001 9.375C9.91668 9.375 12.4075 7.56083 13.4167 5C12.4075 2.43917 9.91668 0.625 7.00001 0.625Z"
                         fill="#888888"
                       ></path>
                     </g>
                     <defs>
                       <clipPath id="clip0_1_298">
                         <rect width="14" height="10" fill="white"></rect>
                       </clipPath>
                     </defs>
                   </svg>
                 )}
               </div>
             </div>
             <div className=" w-full">
               <div className="relative">
                 <label htmlFor="" className="text-black">
                   Re-Enter Password*
                 </label>
                 <input
                   className="w-100 rounded_0"
                   name="confirm_password"
                   value={formData?.confirm_password}
                   type={showConfirmPassword ? "text" : "password"}
                   placeholder="Re-enter password"
                   onChange={handleInputChange}
                 />{" "}
                 {showConfirmPassword ? (
                   <svg
                     onClick={() => setShowConfirmPassword(false)}
                     style={{
                       position: "absolute",
                       top: "32px",
                       right: "5px",
                       cursor: "pointer",
                     }}
                     xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     viewBox="0 0 24 24"
                     fill="none"
                   >
                     <path
                       d="M2 2L22 22"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818"
                       stroke="#888888"
                       strokeWidth="2"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                   </svg>
                 ) : (
                   <svg
                     onClick={() => setShowConfirmPassword(true)}
                     style={{
                       position: "absolute",
                       top: "32px",
                       right: "5px",
                       cursor: "pointer",
                     }}
                     xmlns="http://www.w3.org/2000/svg"
                     width="16"
                     height="16"
                     viewBox="0 0 14 10"
                     fill="none"
                   >
                     <g clipPath="url(#clip0_1_298)">
                       <path
                         d="M7.00001 3.25C6.53588 3.25 6.09076 3.43437 5.76257 3.76256C5.43438 4.09075 5.25001 4.53587 5.25001 5C5.25001 5.46413 5.43438 5.90925 5.76257 6.23744C6.09076 6.56563 6.53588 6.75 7.00001 6.75C7.46414 6.75 7.90926 6.56563 8.23745 6.23744C8.56564 5.90925 8.75001 5.46413 8.75001 5C8.75001 4.53587 8.56564 4.09075 8.23745 3.76256C7.90926 3.43437 7.46414 3.25 7.00001 3.25ZM7.00001 7.91667C6.22646 7.91667 5.4846 7.60938 4.93762 7.06239C4.39063 6.51541 4.08334 5.77355 4.08334 5C4.08334 4.22645 4.39063 3.48459 4.93762 2.93761C5.4846 2.39062 6.22646 2.08333 7.00001 2.08333C7.77356 2.08333 8.51542 2.39062 9.0624 2.93761C9.60939 3.48459 9.91668 4.22645 9.91668 5C9.91668 5.77355 9.60939 6.51541 9.0624 7.06239C8.51542 7.60938 7.77356 7.91667 7.00001 7.91667ZM7.00001 0.625C4.08334 0.625 1.59251 2.43917 0.583344 5C1.59251 7.56083 4.08334 9.375 7.00001 9.375C9.91668 9.375 12.4075 7.56083 13.4167 5C12.4075 2.43917 9.91668 0.625 7.00001 0.625Z"
                         fill="#888888"
                       ></path>
                     </g>
                     <defs>
                       <clipPath id="clip0_1_298">
                         <rect width="14" height="10" fill="white"></rect>
                       </clipPath>
                     </defs>
                   </svg>
                 )}
               </div>
             </div>
             <div className="LoginVendor_registerForm_btn w-full">
               <button type="submit" className="red_new_btn_black">
                 CREATE ACCOUNT
               </button>
             </div>
           </div>
         </div>
       </form>
     )} */}
            {multiStep === 3 && (
              <>
                {" "}
                <form action="">
                  <div className="inner_form_width">
                    {" "}
                    <div className="LoginVendor_registerForm flex">
                      <h3>Enter Company Details</h3>
                      <div className="w-full LoginVendor_registerForm_entry">
                        <div className="input-flex">
                          {" "}
                          <div>
                            <label htmlFor="" className="text-black">
                              Business Name*
                            </label>
                            <input
                              //   style={
                              //     formErrors.name && {
                              //       backgroundColor: "#ff000040",
                              //       border: "1px solid red",
                              //     }
                              //   }
                              className="w-full rounded_0"
                              onChange={handleInputChange}
                              name="business_name"
                              value={formData?.business_name}
                              type="text"
                              placeholder="Enter business name"
                            />
                          </div>
                          <div>
                            <label htmlFor="" className="text-black">
                              Contact Number*
                            </label>
                            <input
                              //   style={
                              //     formErrors.name && {
                              //       backgroundColor: "#ff000040",
                              //       border: "1px solid red",
                              //     }
                              //   }
                              className="w-full rounded_0"
                              onChange={handleInputChange}
                              name="phone"
                              value={formData?.phone}
                              type="number"
                              placeholder="Enter contact number"
                            />
                          </div>
                        </div>
                        <div className="input-flex">
                          {" "}
                          <div>
                            <label htmlFor="" className="text-black">
                              Business Email*
                            </label>
                            <input
                              className="w-full rounded_0"
                              name="business_email"
                              value={formData?.business_email}
                              onChange={handleInputChange}
                              type="email"
                              placeholder="example@email.com"
                            />
                          </div>
                          <div>
                            <label htmlFor="" className="text-black">
                              Website Link
                            </label>
                            <input
                              className="w-full rounded_0"
                              name="website_link"
                              type="url"
                              value={formData?.website_link}
                              onChange={handleInputChange}
                              placeholder="Enter website link"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="LoginVendor_registerForm_btn w-full">
                        <button
                          type="submit"
                          className="red_new_btn_black"
                          onClick={() => setMultiStep(4)}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </>
            )}
            {multiStep === 4 && (
              <form action="">
                <div className="inner_form_width">
                  {" "}
                  <div className="LoginVendor_registerForm flex">
                    <h3>Enter Legal Details</h3>
                    <div className="w-full LoginVendor_registerForm_entry">
                      <div className="input-flex">
                        {" "}
                        <div>
                          <label htmlFor="" className="text-black">
                            Company GST*
                          </label>
                          <input
                            className="w-full rounded_0"
                            name="gst"
                            value={formData?.gst}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Enter GST"
                          />
                        </div>
                        <div>
                          <label htmlFor="" className="text-black">
                            Company PAN*
                          </label>
                          <input
                            className="w-full rounded_0"
                            name="pan"
                            value={formData?.pan}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Enter PAN"
                          />
                        </div>
                        <div>
                          <label htmlFor="" className="text-black">
                            Company TAN
                          </label>
                          <input
                            className="w-full rounded_0"
                            name="tan"
                            value={formData?.tan}
                            onChange={handleInputChange}
                            type="text"
                            placeholder="Enter TAN"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="LoginVendor_registerForm_btn w-full">
                      <button
                        type="submit"
                        className="red_new_btn_black"
                        onClick={() => setMultiStep(5)}
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
            {multiStep === 5 && (
              <form
                action=""
                onSubmit={(e) => setMultiStep((prev) => prev + 1)}
              >
                <div className="inner_form_width">
                  {" "}
                  <div className="LoginVendor_registerForm flex">
                    <h3>Enter Billing Address</h3>
                    <div className="w-full LoginVendor_registerForm_entry">
                      <div className="mt-10">
                        <label htmlFor="" className="text-black">
                          Address*
                        </label>
                        <AddressAutocomplete
                          formdata={formData}
                          onAddressChange={handleAddressData}
                        />
                      </div>

                      <div className="mt-10">
                        <label htmlFor="" className="text-black">
                          ZIP Code*
                        </label>
                        <input
                          className="w-full rounded_0"
                          name="zipcode"
                          value={formData?.zipcode}
                          onChange={handleInputChange}
                          type="text"
                          placeholder="Enter ZIP Code"
                        />
                      </div>
                    </div>

                    <div className="LoginVendor_registerForm_btn w-full">
                      <button type="submit" className="red_new_btn_black">
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
            {multiStep === 6 && (
              <form
                action=""
                onSubmit={(e) => {
                  handleSubmit(e);
                  setTimeout(() => handleSubmit(e), 300);
                }}
              >
                <div className="inner_form_width">
                  {" "}
                  <div className="LoginVendor_registerForm flex">
                    <h3>Enter Contact Person Details</h3>
                    <div className="w-full LoginVendor_registerForm_entry">
                      {" "}
                      <div>
                        <label htmlFor="" className="text-black">
                          Person Name*
                        </label>
                        <input
                          className="w-full rounded_0"
                          name="person_name"
                          onChange={handleInputChange}
                          value={formData?.person_name}
                          type="text"
                          placeholder="Enter name"
                        />
                      </div>
                      <div className="input-flex">
                        {" "}
                        <div>
                          <label htmlFor="" className="text-black">
                            Person Contact Number*
                          </label>
                          <input
                            className="w-full rounded_0"
                            name="person_contact"
                            type="number"
                            onChange={handleInputChange}
                            value={formData?.person_contact}
                            placeholder="Enter contact number"
                          />
                        </div>
                        <div>
                          <label htmlFor="" className="text-black">
                            Person Email*
                          </label>
                          <input
                            className="w-full rounded_0"
                            type="email"
                            name="person_email"
                            onChange={handleInputChange}
                            value={formData?.person_email}
                            placeholder="Enter email"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="LoginVendor_registerForm_btn w-full">
                      <button type="submit" className="red_new_btn_black">
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AgentRegistration;
